<!--
	TEMPLATE
-->
<template>
<div class="editable-text">
	<div v-if="!isEditView" :class="{'text-italic': value === ''}">{{ label }}</div>

	<div v-if="isEditView">
		<textarea :rows="options.rows" :maxlength="options.limit" @input="$emit('input', $event.target.value)">{{ value }}</textarea>
		<div v-if="options.limit > 0 && value !== ''" class="editable-text__counter">
			<span v-if="value.length === options.limit">You've reached the limit of {{ options.limit }} letters!</span>
			<span v-else>{{ value.length }}/{{ options.limit }}</span>
		</div>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			isEmpty: false
		}
	},
	computed: {
		label: function() {
			return this.value === '' ? 'There is no content here yet!' : this.value
		}
	}
}
</script>
